
import React from "react";
import { useStrategiesTable } from "./StrategiesTableProvider";
import { StrategyFormDialog } from "@/components/admin/strategy-form/StrategyFormDialog";
import StrategyDetail from "@/components/StrategyDetail";
import DeleteStrategyDialog from "./DeleteStrategyDialog";
import { StrategyProvider, StrategyWithDetails } from "@/types/strategy-types";

interface StrategiesDialogsProps {
  providers: StrategyProvider[];
  onCreateStrategy: (strategy: Partial<StrategyWithDetails>) => Promise<void>;
  onUpdateStrategy: (id: string, strategy: Partial<StrategyWithDetails>) => Promise<void>;
  onDeleteStrategy: (id: string) => Promise<void>;
  userRole?: string | null;
}

const StrategiesDialogs = ({
  providers,
  onCreateStrategy,
  onUpdateStrategy,
  onDeleteStrategy,
  userRole
}: StrategiesDialogsProps) => {
  const {
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    editingStrategy,
    setEditingStrategy,
    previewStrategy,
    setPreviewStrategy
  } = useStrategiesTable();

  const handleCloseCreateDialog = () => {
    setIsCreateDialogOpen(false);
  };

  const handleCloseEditDialog = () => {
    setEditingStrategy(null);
  };

  const handleClosePreviewDialog = () => {
    setPreviewStrategy(null);
  };

  return (
    <>
      {/* Create Strategy Dialog */}
      <StrategyFormDialog
        isOpen={isCreateDialogOpen}
        onClose={handleCloseCreateDialog}
        onSubmit={onCreateStrategy}
        providers={providers}
        userRole={userRole}
      />

      {/* Edit Strategy Dialog */}
      {editingStrategy && (
        <StrategyFormDialog
          isOpen={!!editingStrategy}
          onClose={handleCloseEditDialog}
          onSubmit={(strategy) => onUpdateStrategy(editingStrategy.id, strategy)}
          initialData={editingStrategy}
          providers={providers}
          userRole={userRole}
        />
      )}

      {/* Preview Strategy Dialog */}
      {previewStrategy && (
        <StrategyDetail
          isOpen={!!previewStrategy}
          onClose={handleClosePreviewDialog}
          strategy={previewStrategy as any}
        />
      )}

      {/* Delete Strategy Dialog */}
      <DeleteStrategyDialog onDeleteStrategy={onDeleteStrategy} />
    </>
  );
};

export default StrategiesDialogs;
